import { db } from '@/firebase/init';
import { InvitationFromStore } from '@/types/types';
import { getOrganizationInvitationsPath } from '@/utils/queryPaths';
import { collection, orderBy, query } from 'firebase/firestore';
import { useMemo } from 'react';
import { useFirestoreCollection } from '../hooks/useFirestoreCollection';

function useOrganizationInvitations(
  organizationId: string,
): InvitationFromStore<'organization'>[] {
  const invitationsQuery = useMemo(
    () =>
      query(
        collection(db, getOrganizationInvitationsPath(organizationId)),
        orderBy('invitedUserEmail', 'asc'),
      ),
    [organizationId],
  );

  const invitations = useFirestoreCollection<InvitationFromStore<'organization'>>(
    ['organizationInvitations', organizationId],
    invitationsQuery,
  );

  return invitations;
}

export { useOrganizationInvitations };
